// extracted by mini-css-extract-plugin
export default {"form_page":"Form_form_page__bquhY","form_option":"Form_form_option__Zn+3W","center_txt":"Form_center_txt__8vIzM"};